import './style.scss';
import { marked } from "marked";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageNavigation from "../../shared/page-navigation";
import RandomHeadImage from '../../shared/random-head-image';
import Breadcrumb from '../../shared/breadcrumb';

// Configure marked with legacy API for version 12
marked.setOptions({
  gfm: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false
});

const topNavigation = (pageSettings) => {
    if (!pageSettings || !pageSettings.navigation) {
        return <></>;
    }
    const filteredNavigation = {
        ...pageSettings.navigation,
        items: pageSettings.navigation.items.filter((item) => item.link !== pageSettings.location)
    };

    return (
        <PageNavigation {...filteredNavigation} />
    );
}

const ArticleContentPage = () => {
    const location = useLocation();
    const [pageSettings, setPageSettings] = useState(null);
    const [content, setContent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const pathName = location.pathname.toLowerCase();

        const pathParts = pathName.split('/').slice(1);
        const moduleName = pathParts[0];
        const pathPart = pathParts.slice(1).join('/').replace(/\/$/, ''); // Remove trailing slash
        
        // Set loading state when path changes
        setIsLoading(true);
        
        import(`../${moduleName}`)
            .then((module) => {
                let fullSettings = module.default();
                
                // Ensure fullSettings is an array
                if (!Array.isArray(fullSettings)) {
                    console.error('Module did not return an array of settings');
                    setIsLoading(false);
                    return;
                }
                
                let settings = fullSettings.find((item) => item && item.path === pathPart);
                
                if (settings) {
                    // Create a copy to avoid mutating the original
                    const settingsCopy = { ...settings };
                    settingsCopy.location = pathName;
                    setPageSettings(settingsCopy);
                } else {
                    console.error(`Page not found for path: ${pathName}, pathPart: ${pathPart}`);
                    console.log('Available paths:', fullSettings.map(s => s?.path).filter(Boolean));
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error loading module:', error);
                setIsLoading(false);
            });

    }, [location.pathname]);

    useEffect(() => {
        if (!pageSettings) {
            return;
        }

        if (pageSettings.contentType === 'markdown-url') {
            fetch(`${pageSettings.content}`)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(`Failed to fetch content: ${res.status}`);
                    }
                    return res.text();
                })
                .then((md) => setContent(marked(md))) // Convert markdown to HTML with legacy API
                .catch((error) => {
                    console.error('Error loading content:', error);
                    setContent('<p>Error loading content. Please try again later.</p>');
                });
        } else {
            setContent(pageSettings.content);
        }
    }, [pageSettings]);

    if (isLoading || !pageSettings || !content) {
        return (
            <div className="container">
                <div className="my-5">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading content...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {topNavigation(pageSettings)}
            <RandomHeadImage items={pageSettings.headImages?.items} />
            <div className="container">
                <div className="my-5">
                    {Breadcrumb(pageSettings)}
                    <div dangerouslySetInnerHTML={{ __html: content }} className="article-content">
                    </div>
                </div>
            </div>
        </>
    );
};

export default ArticleContentPage;